// import React from 'react'
// import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
// import {logo} from "../../assets/index"

// const Footer = () => {
//   return (
//     <div className="w-full py-20 h-auto border-b-[1px] border-b-black grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-4 gap-8">
//       <div className="w-full h-full flex flex-col gap-8">
//         <img className="w-32" src={logo} alt="logo" />
//         <div className="flex gap-4">
//           <span className="bannerIcon">
//             <FaFacebookF />
//           </span>
//           <span className="bannerIcon">
//             <FaTwitter />
//           </span>
//           <span className="bannerIcon">
//             <FaLinkedinIn />
//           </span>
//         </div>
//       </div>
//       <div className="w-full h-full">
//         <h3 className="text-xl uppercase text-designColor tracking-wider">
//           Quick Link
//         </h3>
//         <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               About
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Portfolio
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Services
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Blog
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Contact
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//         </ul>
//       </div>
//       <div className="w-full h-full">
//         <h3 className="text-xl uppercase text-designColor tracking-wider">
//           RESOURCES
//         </h3>
//         <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Authentication
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               System Status
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Terms of Service
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Pricing
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Over Right
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//         </ul>
//       </div>
//       <div className="w-full h-full">
//         <h3 className="text-xl uppercase text-designColor tracking-wider">
//           DEVELOPERS
//         </h3>
//         <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden py-6">
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Documentation
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Authentication
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               API Reference
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Support
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//           <li>
//             <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
//               Open Source
//               <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
//             </span>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// }

// export default Footer

import styled from 'styled-components';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import EmailIcon from '@mui/icons-material/Email';
// import InstagramIcon from '@mui/icons-material/Instagram';

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  //background: linear-gradient(100.26deg, rgba(0, 102, 255, 0.05) 42.33%, rgba(150, 0, 225, 0.05) 127.07%);
`;


const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 800px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
`;

const NavLink = styled.a`
color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1.2rem;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const Copyright = styled.p`
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>Sai Rajesh Jaini</Logo>
        <Nav>
          <NavLink href="#home">About</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#resume">Resume</NavLink>
          <NavLink href="#contact">Contact</NavLink>
        </Nav>
        {/* <SocialMediaIcons> */}
          {/* <SocialMediaIcon href={Bio.facebook} target="display"><FacebookIcon /></SocialMediaIcon> */}
          {/* <SocialMediaIcon href={Bio.linkedin} target="display"><LinkedInIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.Email} target="display"><EmailIcon /></SocialMediaIcon> */}
          {/* <SocialMediaIcon href={Bio.insta} target="display"><InstagramIcon /></SocialMediaIcon> */}
        {/* </SocialMediaIcons> */}
        {/* <Copyright>
          &copy; 2024 Sai Rajesh Jaini. All rights reserved.
        </Copyright> */}

      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;